import {
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { GraphqlService } from "../../../../../../services/graphql.service";
import { NotificationService } from "../../../../../../services/notification.service";
import { SettingsService } from "../../../../../../services/settings.service";
import { AppState } from "../../../../../../store";
import { BaseResponse } from "../../../../../../store/base.entity";
import { GET_ZONE_DATA } from "../../../../../../store/entities/warehouse-management/building-zone/building-zone.graphql";
import { WarehouseZone } from "../../../../../../store/entities/warehouse-management/building-zone/building-zone.model";
import {
  SensorBinCoverage
} from "../../../../../../store/entities/warehouse-management/device/device.model";
import {
  selectStoreItems
} from "../../../../../../store/entities/store-item/store-item.selectors";
import { StoreItemEntity } from "../../../../../../store/entities/store-item/store-item.model";
import { StoreItemActions } from "../../../../../../store/entities/store-item/store-item.actions";
import {
  CREATE_SENSOR_BIN_COVERAGE,
  GET_SENSOR_BIN_COVERAGE,
  UPDATE_SENSOR_BIN_COVERAGE,
} from "../../../../../../store/entities/warehouse-management/device/device.graphql";
@Component({
  selector: "app-warehouse-sensor-bins",
  templateUrl: "./warehouse-sensor-bins.component.html",
  styleUrl: "./warehouse-sensor-bins.component.scss",
})
export class WarehouseSensorBinsComponent implements OnInit, OnDestroy {
  @Output()
  onClose = new EventEmitter<any>();

  selectedSensorBinCoverage$: Observable<SensorBinCoverage[]>;
  selectedSensorBinCoverage: SensorBinCoverage[];
  pagination

  routeSub = Subscription.EMPTY;
  selectedUuid: string;

  isLoading: boolean = false;

  allZones: WarehouseZone[];
  allZonesNew: WarehouseZone[];

  permissionsForm: FormGroup;
  formChanged: boolean;
selectedBins: string[] = [];

  selectedSub: Subscription = new Subscription();
// for selecting specific range
  lastSelectedIndex: number | null = null;
  isShiftPressed = false;
binRangeInput: string = ""; // e.g., "A2AA24A - A2AA26A"

  constructor(
    private store: Store<AppState>,
    private apollo: GraphqlService,
    private activeRoute: ActivatedRoute,
    private settingsService: SettingsService,
    private notificationService: NotificationService,
    private fb: FormBuilder
  ) {
    store.dispatch(
      StoreItemActions.getStoreItems({
        entity: StoreItemEntity.sensorBinCoverage,
        filtering: {
          sensorUniqueId: activeRoute.snapshot.queryParams["sensor"],
          pageNumber: 1,
        },
        query: GET_SENSOR_BIN_COVERAGE,
      })
    );
  }

  get permissions(): FormArray {
    return this.permissionsForm.get("permissions") as FormArray;
  }

  async ngOnInit() {
    this.routeSub = this.activeRoute.queryParams.subscribe((items) => {
      this.selectedUuid = items["sensor"];

      if (this.selectedUuid) {
        this.selectedSensorBinCoverage$ = this.store.select(
          selectStoreItems(StoreItemEntity.sensorBinCoverage)
        );
        this.selectedSub.add(
          this.selectedSensorBinCoverage$.subscribe((d) => {
            if (d) {
              this.selectedSensorBinCoverage = d;
this.selectedBins = d[0]?.coveredBins
  ?.map((p) => p.uniqueId)
  ?.filter((id) => !!id) || [];
            }
          })
        );
      }
    });

    await this.loadAllZoneBins();
  }
  async fetchPage(pagination, selectedPage: any) {
    this.isLoading = true
    let page = null
    switch (selectedPage) {
      case "next":
        page = pagination?.nextPageNumber
        break;
      case "prev":
        page = pagination?.previousPageNumber
        break;
      default:
        page = parseInt(selectedPage.target.value, 10)
    }
    try {
      const response: any = await this.apollo.query({
        query: GET_ZONE_DATA,
        variables: {
          filtering: {
            pageNumber: page,
            itemsPerPage: 5,
            warehouse: this.activeRoute.snapshot.queryParams["warehouse"]
          }
        }
      })

      const result: BaseResponse<WarehouseZone[]> = Object.values(
        Object.values(response)[0]
      )[0];

      if (result?.response?.status) {
        this.pagination = result.page
        this.allZones = [...result?.data];
        this.allZonesNew = this.allZones;
        this.isLoading = false;
      } else {
        throw Error(result.response.message);
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message);
    }

    this.isLoading = false;

  }


  async loadAllZoneBins() {
    this.isLoading = true;

    try {
      const response: any = await this.apollo.query({
        query: GET_ZONE_DATA,
        variables: {
          filtering: {
            pageNumber: 1,
            itemsPerPage: 5,
            warehouse: this.activeRoute.snapshot.queryParams["warehouse"]
          },
        },
      });

      const result: BaseResponse<WarehouseZone[]> = Object.values(
        Object.values(response)[0]
      )[0];

      if (result?.response?.status) {
        this.pagination = result.page
        console.log(this.pagination);

        this.allZones = [...result?.data];
        this.allZonesNew = this.allZones;
        this.isLoading = false;
      } else {
        throw Error(result.response.message);
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message);
    }

    this.isLoading = false;
  }

  hasBin(bin: string) {
    return this.selectedBins?.indexOf(bin) > -1;
  }
 selectAllGrouped(grouped: WarehouseZone) {
  this.formChanged = true;

  // Check if all bins in the group are already selected
  const allSelected = grouped.bins.every(bin =>
    this.selectedBins.includes(bin.uniqueId)
  );

  if (allSelected) {
    // Unselect all
    this.selectedBins = this.selectedBins.filter(
      id => !grouped.bins.some(bin => bin.uniqueId === id)
    );
  } else {
    // Select all
    const idsToAdd = grouped.bins
      .map(b => b.uniqueId)
      .filter(id => !this.selectedBins.includes(id));
    this.selectedBins = [...this.selectedBins, ...idsToAdd];
  }
}

getSelectAllText(grouped: WarehouseZone): string {
  if (!grouped?.bins?.length) return 'Select All';

  const allSelected = grouped.bins.every(bin =>
    this.selectedBins.includes(bin.uniqueId)
  );

  return allSelected ? 'Unselect All' : 'Select All';
}


// Keep track of last used range for each zone
rangeState: { [zoneId: string]: { start: number; end: number } } = {};


  // selectBinsByFullRange(grouped: WarehouseZone) {
  //   if (!this.binRangeInput) return;

  //   this.formChanged = true;

  //   // Expect input like "AD02A - AD03B"
  //   const parts = this.binRangeInput.split('-').map(p => p.trim());
  //   if (parts.length !== 2) return;

  //   const startBin = parts[0]; // e.g., "AD02A"
  //   const endBin = parts[1];   // e.g., "AD03B"

  //   // Filter bins in the group lexicographically
  //   const binsInRange = grouped.bins.filter(bin => {
  //     const bn = bin.binNumber;
  //     return bn >= startBin && bn <= endBin;
  //   });

  //   if (!binsInRange.length) return;

  //   // Determine if all are already selected
  //   const allSelected = binsInRange.every(bin => this.selectedBins.includes(bin.uniqueId));

  //   if (allSelected) {
  //     // Unselect
  //     this.selectedBins = this.selectedBins.filter(
  //       id => !binsInRange.some(b => b.uniqueId === id)
  //     );
  //   } else {
  //     // Select
  //     const idsToAdd = binsInRange
  //       .map(b => b.uniqueId)
  //       .filter(id => !this.selectedBins.includes(id));
  //     this.selectedBins = [...this.selectedBins, ...idsToAdd];
  //   }

  //   // Clear input
  //   this.binRangeInput = '';
  // }

selectBinsByFullRange(grouped: WarehouseZone) {
  if (!this.binRangeInput) return;

  const parts = this.binRangeInput.split('-').map(p => p.trim());
  if (parts.length !== 2) return;

  const startBin = parts[0]; 
  const endBin = parts[1];

  const startSuffix = startBin.slice(-1); 
  const endSuffix = endBin.slice(-1);

  const binsInRange = grouped.bins.filter(bin => {
    const bn = bin.binNumber;
    

    const isWithinBounds = bn >= startBin && bn <= endBin;
    

    const matchesSuffix = bn.endsWith(startSuffix) || bn.endsWith(endSuffix);

    return isWithinBounds && matchesSuffix;
  });

  if (!binsInRange.length) return;

  // Toggle selection logic...
  const allSelected = binsInRange.every(bin => this.selectedBins.includes(bin.uniqueId));
  if (allSelected) {
    this.selectedBins = this.selectedBins.filter(id => !binsInRange.some(b => b.uniqueId === id));
  } else {
    const idsToAdd = binsInRange.map(b => b.uniqueId).filter(id => !this.selectedBins.includes(id));
    this.selectedBins = [...this.selectedBins, ...idsToAdd];
  }

  this.formChanged = true;
  this.binRangeInput = '';
}


getRangeActionText(grouped: WarehouseZone): string {
  const range = this.rangeState[grouped.id];
  if (!range) return "Select Range";

  const binsInRange = grouped.bins.filter(bin => {
    const match = bin.binNumber.match(/\d+/g);
    const lastNumber = match ? Number(match[match.length - 1]) : NaN;
    return !isNaN(lastNumber) && lastNumber >= range.start && lastNumber <= range.end;
  });

  const allSelected = binsInRange.every(bin => this.selectedBins.includes(bin.uniqueId));
  return allSelected ? "Unselect Range" : "Select Range";
}
@HostListener('window:keydown', ['$event'])
handleKeyDown(event: KeyboardEvent) {
  if (event.key === 'Shift') {
    this.isShiftPressed = true;
  }
}

@HostListener('window:keyup', ['$event'])
handleKeyUp(event: KeyboardEvent) {
  if (event.key === 'Shift') {
    this.isShiftPressed = false;
  }
}
onChange(
  uniqueId: string,
  event: MatCheckboxChange,
  bins: any[],
  currentIndex: number
) {
  this.formChanged = true;

  if (this.isShiftPressed && this.lastSelectedIndex !== null) {
    const start = Math.min(this.lastSelectedIndex, currentIndex);
    const end = Math.max(this.lastSelectedIndex, currentIndex);

    for (let i = start; i <= end; i++) {
      const id = bins[i].uniqueId;

      if (event.checked) {
        if (!this.selectedBins.includes(id)) {
          this.selectedBins.push(id);
        }
      } else {
        const index = this.selectedBins.indexOf(id);
        if (index > -1) {
          this.selectedBins.splice(index, 1);
        }
      }
    }
  } else {
    if (event.checked) {
      if (!this.selectedBins.includes(uniqueId)) {
        this.selectedBins.push(uniqueId);
      }
    } else {
      const index = this.selectedBins.indexOf(uniqueId);
      if (index > -1) {
        this.selectedBins.splice(index, 1);
      }
    }
  }

  this.lastSelectedIndex = currentIndex;
}

  async saveChanges() {
    this.isLoading = true;

    try {
      this.store.dispatch(
        StoreItemActions.createUpdateStoreItem({
          entity: StoreItemEntity.sensorBinCoverage,
          isInput: true,
          input: {
            sensorUniqueId: this.selectedSensorBinCoverage[0]?.sensorUniqueId,
              zoneBin: this.selectedBins.filter((id) => !!id),

          },
          mutation: this.selectedSensorBinCoverage[0]?.coveredBins.length > 0 ? UPDATE_SENSOR_BIN_COVERAGE : CREATE_SENSOR_BIN_COVERAGE
        })
      );

      this.isLoading = false;
      this.notificationService.successMessage("Operation Successful");
    } catch (e) {
      this.notificationService.errorMessage(e.message);
    }

    this.isLoading = false;
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }
}
